// extracted by mini-css-extract-plugin
export default {"wrapper":"secondTaskSandbox_wrapper__R4H+x","options":"secondTaskSandbox_options__crwNz","plusIcon":"secondTaskSandbox_plusIcon__Gvf57"};